export default __webpack_public_path__ + "static/media/gsm_5.f93e82b3.svg";